import React from 'react';
import { PortableText } from '@portabletext/react';
import ExternalLink from '../external-link/externalLink';
import StoryVideoBlock from '../StoryVideoBlock';
import StoryImages from '../StoryImages';

const components = {
	types: {
		StoryVideoBlock,
		StoryImages,
	},
	marks: {
		internalLink: ({ value, children }) => {

			const href = `${value.reference.pageRelativeURL}`;
			return <a href={href}>{children}</a>;
		},
		link: ({ value, children }) => {
			const { blank, href } = value;
			return blank ? (
				<ExternalLink href={value.external ? value.external : href}>
					{children}
				</ExternalLink>
			) : (
				<a href={value.external ? value.external : href}>{children}</a>
			);
		},
	},
};

export const MyPortableText = (props) => {
	return <PortableText value={props.value} components={components} />;
};
